module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/reason_03_sp-3a98c8a46428928f6c80936302ffd3aa.png";